/* Auf- und Zuklappen des Gewährleistungshinweises.
   Delegiert am document, damit auch nachgeladene Warenkörbe funktionieren. */
(function () {
  if (window.__warrantyNoticeInit) return;
  window.__warrantyNoticeInit = true;

  function setzen(notiz, offen) {
    var schalter = notiz.querySelector('[data-warranty-toggle]');
    var feld = notiz.querySelector('[data-warranty-panel]');
    if (!schalter || !feld) return;
    schalter.setAttribute('aria-expanded', offen ? 'true' : 'false');
    feld.hidden = !offen;
  }

  document.addEventListener('click', function (e) {
    var schalter = e.target.closest('[data-warranty-toggle]');
    if (schalter) {
      var n = schalter.closest('[data-warranty-notice]');
      if (n) setzen(n, schalter.getAttribute('aria-expanded') !== 'true');
      return;
    }
    // Klick auf das aufgeklappte Label schließt es wieder, Links ausgenommen
    var feld = e.target.closest('[data-warranty-panel]');
    if (feld && !e.target.closest('a')) {
      var m = feld.closest('[data-warranty-notice]');
      if (m) setzen(m, false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var offen = document.querySelectorAll('[data-warranty-toggle][aria-expanded="true"]');
    if (!offen.length) return;
    e.stopPropagation(); // sonst schließt Esc gleichzeitig die Warenkorb-Schublade
    Array.prototype.forEach.call(offen, function (s) {
      var n = s.closest('[data-warranty-notice]');
      if (n) setzen(n, false);
      s.focus();
    });
  }, true);
})();
